module.exports = __webpack_public_path__ + "static/img/icon-deux-maisons-vert.b026dfe2.svg";